// --------------------------- LOCATION ---------------------------
export const BASE_URL = window?.env?.API_URL || process?.env?.API_URL || '';
// ----------------------------- FORM -----------------------------
// get
export const GET_ENTRIES = (token) => `/v1/surveys/entries/${token}`;
// post
export const POST_ANSWERS = (token) => `/v1/surveys/answers/${token}`;
// post
export const SAVE_DRAFT = (token) => `/v1/surveys/answers/${token}/draft`;
